import axios from "axios";
import Errores from "@/utils/Errores";

export const ApiDirectorio = {
  obtenerInformacion: async (componente, tokenBearer) => {
    try {
      //GET
      const response = await axios.get(
        API.DIRECTORIO + "parametrosGenerales/",
        {
          headers: {
            Authorization: `Bearer ${tokenBearer}`
          }
        }
      );
      if (response.data) {
        let parametroModoRecuperarPassword = response.data.find(
          elemento => elemento.llave === "modoRecuperarPassword"
        );
        return {
          parametroModoRecuperarPassword
        };
      } else {
        console.error("Respuesta de API incorrecta");
        return null;
      }
    } catch (error) {
      Errores.switchErrors(error, componente);
      console.error(
        "Error al cargar parámetros iniciales:",
        error.response || error.message || error
      );
      return null;
    }
  }
};

export default ApiDirectorio;



// WEBPACK FOOTER //
// ./src/services/ApiDirectorio.js